const MY_PROFILE_TYPE = {
  PersonalDetails: 'personalDetails',
  Subscription: 'subscription',
};

export default MY_PROFILE_TYPE;
